module.exports = __webpack_public_path__ + "static/portoseguro-a5369f44f598af0d434b7e0aed1f4136.jpg";